import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminPage } from './admin';

@NgModule({
  declarations: [
    AdminPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminPage),
  ],
  entryComponents: [
    AdminPage
  ]
})
export class AdminPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin/admin.module.ts